import React from "react";

const Footer = () => (
  <div className="mt-24">
    <p className="dark:text-gray-200 text-gray-700 text-center m-20 font-semibold">
      Application by{" "}
      <a
        href="https://github.com/mukand-mapara"
        target="_blank"
        rel="noopener noreferrer"
      >
        Mukand_Mapara
      </a>
    </p>

    <p className="dark:text-gray-200 text-gray-700 text-center m-20">
      © 2022 All rights reserved by{" "}
      <a
        href="https://github.com/mukand-mapara"
        target="_blank"
        rel="noopener noreferrer"
      >
        Shopit.com
      </a>
    </p>
  </div>
);

export default Footer;
